import axios from 'axios'

axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";
// 创建实例
const http = axios.create({
    // 通用请求地址的前缀
    baseURL: '/api', //表示以当前启动位置的localhost的8081位baseURL
    timeout: 10000, //超时时间,单位是毫秒，如果这段时间内后端没有响应，那就终止请求
})
// 添加请求拦截器
http.interceptors.request.use(function (config) {

    // 在发送请求之前做些什么
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // 添加自定义请求头
    config.headers['X-Requested-With'] = 'KBeyJ1bmlxdWVfbmFtZSI6IueuoeeQhu';
    config.headers['X-Client-Token'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IueuoeeQhuWRmCIsInJvbGUiOiJBZG1pbiIsIm5iZiI6MTczMzg5Nzk0NywiZXhwIjoxNzMzOTQxMTQ3LCJpYXQiOjE3MzM4OTc5NDcsImlzcyI6Iktub3dsZWRnZUJhc2UiLCJhdWQiOiJLbm93bGVkZ2VCYXNlQ2xpZW50In0.qAuHazzrU8GrtPE1csH0ObQJsOUz6_4-bv9Sg9C7gJ0';


    if (config.method === "get" && config.params) {
        let url = config.url + "?" + tansParams(config.params);
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response;
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
});

export function tansParams(params) {
    let result = '';
    for (const propName of Object.keys(params)) {
        const value = params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && value !== "" && typeof (value) !== "undefined") {
            if (typeof value === 'object') {
                for (const key of Object.keys(value)) {
                    if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        result += subPart + encodeURIComponent(value[key]) + "&";
                    }
                }
            } else {
                result += part + encodeURIComponent(value) + "&";
            }
        }
    }
    return result;
}

// 将实例对外暴露
export default http